/* eslint-disable no-new, no-restricted-syntax */
import React, { useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';
import { listSellingTerminalsRequest } from 'store/ducks/sellingTerminals/actions';

// Types
import { ApplicationState } from 'store';
import { SellingTerminalInterface } from 'store/ducks/sellingTerminals/types';

// Styles
import useStyles from './SellingTerminalFilter.styles';

const SellingTerminalFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const filteredSellingTerminal = useSelector(
    (state: ApplicationState) => state.reports.selectedSellingTerminal,
  );

  const sellingTerminalList = useSelector(
    (state: ApplicationState) => state.sellingTerminals.sellingTerminalsList,
  );

  const handlesellingTerminal = (sellingTerminal: SellingTerminalInterface) => {
    const updated = [...filteredSellingTerminal];
    const index = filteredSellingTerminal.findIndex(
      (s) => s.id === sellingTerminal.id,
    );

    if (index === -1) {
      updated.push({
        id: sellingTerminal.id || '',
        name: sellingTerminal.name || '',
      });
    } else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedSellingTerminal({
        selectedSellingTerminal: updated,
      }),
    );
  };

  useEffect(() => {
    if (!sellingTerminalList.length) {
      dispatch(listSellingTerminalsRequest({ body: { _limit: 9999 } }));
    }
  }, [dispatch, sellingTerminalList]);

  return (
    <Box marginTop={1}>
      <List dense>
        {Array.isArray(sellingTerminalList) &&
          sellingTerminalList.map((sellingTerminal) => (
            <ListItem key={sellingTerminal.id} button>
              <ListItemText
                id={sellingTerminal.id}
                primary={sellingTerminal.name}
                onClick={() => handlesellingTerminal(sellingTerminal)}
                classes={{ root: classes.itemText }}
              />
              <ListItemSecondaryAction>
                <Checkbox
                  edge='end'
                  color='primary'
                  onClick={() => handlesellingTerminal(sellingTerminal)}
                  checked={
                    !!filteredSellingTerminal.find(
                      (s) => s.id === sellingTerminal.id,
                    )
                  }
                  inputProps={{ 'aria-labelledby': sellingTerminal.id }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export { SellingTerminalFilter };
export default SellingTerminalFilter;
